import firebase from '@firebase/app'
import '@firebase/auth'
import '@firebase/firestore'
import '@firebase/storage'

const config = {
  apiKey: 'AIzaSyCR5xLqxxhN-nFwtlX26Ov_kjAE_6NRHr4',
  authDomain: 'fb-wotsnu.firebaseapp.com',
  databaseURL: 'https://fb-wotsnu.firebaseio.com',
  projectId: 'fb-wotsnu',
  storageBucket: 'fb-wotsnu.appspot.com',
  messagingSenderId: '937055345942'
}
firebase.initializeApp(config)

const db = firebase.firestore()
const auth = firebase.auth()
const storage = firebase.storage()

const settings = { timestampsInSnapshots: true }
db.settings(settings)

const usersCollection = db.collection('users')
const postsCollection = db.collection('posts')
const groupsCollection = db.collection('groups')
const commentsCollection = db.collection('comments')

export {
  db,
  auth,
  storage,
  usersCollection,
  postsCollection,
  groupsCollection,
  commentsCollection
}



// WEBPACK FOOTER //
// ./src/firebase.js